import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'htmlSafePipe' })
export class HtmlSafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(valor) {
    return this.sanitizer.bypassSecurityTrustHtml(valor);
  }
}
